<template>
  <base-draggable-modal
      :name="modal_name"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="modal_name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title v-if="revisions.length > 0" class="text-primary">{{ $store.getters.translate(revisions[current_revision].audit_event) + ' by ' + revisions[current_revision].audit_user_name + ' on ' + moment(revisions[current_revision].audit_created_at).format("DD-MM-YYYY HH:mm") + ' (Revision ' + (current_revision+1) + ')' }}</v-toolbar-title>
            <v-toolbar-title v-else class="text-primary">{{ $store.getters.translate(page.model) }}</v-toolbar-title>
            <v-spacer/>
            <base-action-button v-if="current_revision > 0" class="mr-5" @action="previousRevision">
              <template #prepend><PhArrowFatLeft style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("previous") }}
            </base-action-button>
            <base-action-button v-if="current_revision < revisions.length - 1" class="mr-5" @action="nextRevision">
              {{ $store.getters.translate("next") }}
              <template #append><PhArrowFatRight style="vertical-align: middle; margin-left: 5px;" size="20" /></template>
            </base-action-button>
          </v-toolbar>
        </template>
        <template #content>
            <v-card-text v-if="revisions.length > 0">
              <!--USUAL FIELDS-->
              <base-field
                  v-for="field in usual_fields"
                  :key="field.name"
                  :isDisabled="true"
                  :modelValue="revisions[current_revision][field.name]"
                  :field="field"/>
            </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal(modal_name)">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import BaseLinkButton from "./BaseLinkButton";
import {PhArrowFatLeft, PhArrowFatRight, PhArrowSquareOut, PhX} from "@phosphor-icons/vue";
import moment from "moment";

export default {
  props: ["modal_name", "page"],
  components: {
    BaseLinkButton,
    BaseModal,
    BaseDraggableModal,
    BaseActionButton,
    PhArrowFatRight, PhArrowFatLeft, PhArrowSquareOut, PhX,
  },
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      revisions: [],
      current_revision: 0,
      usual_fields: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(id) {
      this.openModal(this.modal_name);
      //let record = await helpFunctions.loadModel(this.$toast, this.page.name, id);
      let audits = await helpFunctions.getCustomRoute(this.$toast, "audits?model=" + this.page.model + "&id=" + id);

      for (let i = 0; i < audits.length; i++) {
        if(i === 0) {
          this.revisions[i] = {};
        } else {
          this.revisions[i] = this.$lodash.cloneDeep(this.revisions[i-1]);
        }
        Object.entries(audits[i].new_values).forEach(([key, value]) => {
          if((key === 'start_date' || key === 'complete_date') && value) {
            value = moment(value, "YYYY-MM-DD").format("DD-MM-YYYY");
          }
          this.revisions[i][key] = value;
        });
        this.revisions[i].audit_event = audits[i].event;
        this.revisions[i].audit_user_name = audits[i].user_name;
        this.revisions[i].audit_created_at = audits[i].created_at;
      }

      await this.getFields();
    },
    previousRevision() {
      this.current_revision--;
    },
    nextRevision() {
      this.current_revision++;
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_update");
      this.usual_fields = response.usual_fields;
    },
  },
};
</script>

<style scoped>
.v-toolbar-title >>> .v-toolbar-title__placeholder {
  overflow: visible !important;
}
</style>